export default function () {
    const $form = document.getElementById('searchForm');

    if (!$form) {
        return;
    }

    $form.addEventListener('submit', e => e.preventDefault());

    const $searchBox = $form.querySelector('#txtSearchTerm');

    if (!$searchBox) {
        return;
    }

    $searchBox.addEventListener('focus', function onFocus() {
        import('./searchcontrol.js').then(({ default: searchControl }) => {
            searchControl.init($searchBox);

            import('./searchsuggestions.js').then(({ default: searchSuggestions }) => {
                searchSuggestions.init($searchBox, searchControl);
            });
        });

        $searchBox.removeEventListener('focus', onFocus);
    });
}
